import React from 'react';
import Head from 'next/head';

export const MetaTags = (props) => {
  return (
    <Head>
      <title>{props?.meta?.MetaTitle}</title>
      <meta name="description" content={props?.meta?.MetaDescription} />

      <meta property="fb:app_id" content="263680607075199" />
      <meta property="fb:admins" content="1030603473" />
      <meta property="og:description" content={props?.meta?.MetaDescription} />
      <meta property="og:title" content={props?.meta?.MetaTitle} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={props?.meta?.canonical} />
      <meta property="og:image" content={props?.meta?.image} />
      <meta property="og:site_name" content={props?.meta?.canonical} />

      <meta property="twitter:account_id" content="4503599630205252" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Platzi" />
      <meta name="twitter:title" content={props?.meta?.MetaTitle} />
      <meta name="twitter:description" content={props?.meta?.MetaDescription} />
      <meta name="twitter:creator" content="@Platzi" />
      <meta name="twitter:image" content={props?.meta?.image} />
      <meta name="twitter:domain" content={props?.meta?.canonical} />

      <link rel="canonical" href={props?.meta?.canonical} />
    </Head>
  );
};
